import { render, staticRenderFns } from "./RollOptionEditDialog.vue?vue&type=template&id=61ddf8dd&scoped=true&"
import script from "./RollOptionEditDialog.vue?vue&type=script&lang=ts&"
export * from "./RollOptionEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RollOptionEditDialog.vue?vue&type=style&index=0&id=61ddf8dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ddf8dd",
  null
  
)

export default component.exports